import type { GossipEvent } from "@/types/content";

export const events: GossipEvent[] = [
  {
    id: "limited-icecream-soldout",
    title: "联名冰淇淋「上线即秒空」争议复盘",
    category: "品牌商业",
    categorySlug: "brand",
    heat: 96,
    status: "已澄清",
    date: "2026-08-12",
    updatedAt: "2026-08-19",
    cover:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20limited%20edition%20colorful%20dessert%20packaging%20on%20a%20clean%20warm%20cream%20studio%20background%2C%20coral%20and%20amber%20accent%20lighting%2C%20soft%20cinematic%20shadows%2C%20editorial%20product%20photography%2C%20minimal%20composition%2C%20high%20detail&width=800&height=600&seq=gualine-brand-icecream-01&orientation=landscape",
    tags: ["联名营销", "饥饿营销", "库存质疑"],
    summary:
      "一款联名冰淇淋开售 30 秒售罄，随后被质疑「根本没那么大库存」，品牌方公布分批放量规则后舆论才逐步降温。",
    background:
      "某新锐冰淇淋品牌与动画 IP 联名，主打限量口味与限定包装。开售前全网预约人数破百万，但首批库存仅数万份，导致大量用户守着页面却点不进去，矛盾迅速从「抢不到」升级为「是不是在演戏」。",
    people: [
      { name: "品牌方 A 团队", role: "联名发起方" },
      { name: "平台运营", role: "发售页面承接方" },
      { name: "首批抢购用户", role: "争议第一现场" },
      { name: "数码博主「阿饼」", role: "库存数据的搬运与解读" },
    ],
    timeline: [
      {
        date: "08-12 10:00",
        title: "联名官宣，预约量冲上百万",
        desc: "品牌发布联名短片与口味海报，同步开启预约通道，半天内预约数突破百万，话题登上热搜前列。",
        tag: "预热",
      },
      {
        date: "08-15 20:00",
        title: "开售 30 秒显示售罄",
        desc: "首批限量口味上线后迅速显示无货，大量用户卡在支付页，社交平台开始出现「秒空截图」合集。",
        tag: "开售",
      },
      {
        date: "08-15 23:00",
        title: "「假库存」质疑发酵",
        desc: "有博主晒出页面库存接口数据，认为实际放量远低于宣传的限量数，质疑品牌借无货制造话题。",
        tag: "反转",
      },
      {
        date: "08-17 14:00",
        title: "品牌发布分批放量说明",
        desc: "品牌方回应称「限量」指整个发售周期总量，并非单批库存，并公布后续三轮补货时间表。",
        tag: "回应",
      },
      {
        date: "08-19 11:00",
        title: "第三方复核数据，事件收尾",
        desc: "多位用户比对三轮补货的页面数据，确认总量与宣传基本吻合，讨论转向「抢购体验」而非「是否造假」。",
        tag: "收尾",
      },
    ],
    conclusion:
      "这次争议的核心并非「有没有库存」，而是信息差：宣传中的「限量」与用户理解的「单批限量」不一致，加上超高并发下的页面体验，放大了不信任感。品牌后续用分批放量规则补齐了信息，是这次事件降温的关键。",
    views: "412 万",
    readingTime: "6 分钟",
  },
  {
    id: "festival-cancel-refund",
    title: "户外音乐节临时取消，退票为何扯了七天",
    category: "音乐演出",
    categorySlug: "music",
    heat: 91,
    status: "已结束",
    date: "2026-07-26",
    updatedAt: "2026-08-03",
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20outdoor%20music%20festival%20stage%20at%20dusk%20with%20warm%20amber%20stage%20lights%20and%20crowd%20barriers%2C%20moody%20cinematic%20atmosphere%2C%20coral%20and%20gold%20tones%2C%20editorial%20photography%2C%20minimal%20composition%2C%20high%20detail&width=800&height=600&seq=gualine-music-festival-02&orientation=landscape",
    tags: ["退票", "演出取消", "票务规则"],
    summary:
      "演出前一天因极端天气取消，主办方、票务平台与场地方各执一词，退票流程拖了七天，最终由平台先行垫付。",
    background:
      "一场连续三天的户外音乐节在开幕前一天被紧急叫停。主办方称天气预警达到强制停工等级，但已经售出的票、已产生的交通住宿费用由谁承担，成为争论焦点。",
    people: [
      { name: "主办方 B 文化", role: "演出组织与场地协调" },
      { name: "票务平台", role: "售票与退款通道" },
      { name: "外地赶来的乐迷", role: "差旅损失承担方" },
      { name: "当地文旅部门", role: "天气预警与安全裁定" },
    ],
    timeline: [
      {
        date: "07-26 18:00",
        title: "气象预警升级，演出紧急叫停",
        desc: "当地发布强对流天气预警，主办方宣布延期，已进场的观众被引导有序离场。",
        tag: "突发",
      },
      {
        date: "07-27 10:00",
        title: "退票口径出现分歧",
        desc: "主办方公告称「票款可退，差旅损失不在承担范围」，大量已到场的乐迷表示无法接受。",
        tag: "争议",
      },
      {
        date: "07-29 16:00",
        title: "票务平台被指「踢皮球」",
        desc: "用户提交退款后长时间显示「审核中」，平台客服回应称需等待主办方确认，双方互指流程卡在对方。",
        tag: "发酵",
      },
      {
        date: "07-31 09:00",
        title: "监管部门介入协调",
        desc: "文旅部门约谈主办方与票务平台，明确要求先保障消费者退款，再协商其他费用分摊。",
        tag: "介入",
      },
      {
        date: "08-03 12:00",
        title: "平台先行垫付，退款到账",
        desc: "票务平台宣布对全部订单先行垫付退款，后续与主办方结算，事件基本收尾。",
        tag: "解决",
      },
    ],
    conclusion:
      "演出取消本身属于不可抗力，但「谁先退钱」考验的是流程设计。当主办方、平台、场地方三方都在等对方确认时，消费者就成了流程缝隙里唯一没有话语权的一方。这次最终靠监管介入和平台垫付破局，也给同类活动提了个醒：退票预案必须写进合同里。",
    views: "338 万",
    readingTime: "7 分钟",
  },
  {
    id: "newcomer-role-swap",
    title: "新人演员临阵换角，真是「档期冲突」吗",
    category: "娱乐圈",
    categorySlug: "celeb",
    heat: 88,
    status: "待回应",
    date: "2026-08-21",
    updatedAt: "2026-09-02",
    cover:
      "https://readdy.ai/api/search-image?query=Film%20clapperboard%20and%20director%20chair%20on%20a%20minimal%20studio%20set%20with%20warm%20spotlight%2C%20coral%20and%20amber%20tones%2C%20cinematic%20editorial%20photography%2C%20soft%20shadows%2C%20high%20detail&width=800&height=600&seq=gualine-celeb-clapboard-03&orientation=landscape",
    tags: ["换角", "档期", "剧组传闻"],
    summary:
      "开机前一周官宣换角，剧组称「档期协调未果」，但有匿名爆料指向试戏表现与投资方意见，双方至今未正面回应。",
    background:
      "一部未播先热的都市剧原本由一位新人演员出演女二号，定妆照已拍摄完成。距离开机一周时，剧组突然发布换角公告，新演员火速补位。",
    people: [
      { name: "原定演员 C 某", role: "被替换的女二号" },
      { name: "剧组制片方", role: "换角公告发布方" },
      { name: "接替演员 D 某", role: "临时补位" },
      { name: "匿名剧组工作人员", role: "爆料来源" },
    ],
    timeline: [
      {
        date: "08-21 15:00",
        title: "定妆照流出，角色受期待",
        desc: "一组定妆照在社交平台传播，原定演员的造型获得不少好评，话题热度上升。",
        tag: "预热",
      },
      {
        date: "08-28 10:00",
        title: "剧组发布换角公告",
        desc: "公告仅称「因档期协调未果，经双方友好协商更换演员」，未提及具体原因。",
        tag: "官宣",
      },
      {
        date: "08-29 20:00",
        title: "匿名爆料出现",
        desc: "自称剧组工作人员的账号称换角与「试戏效果」及「投资方意见」有关，与官方口径不符。",
        tag: "爆料",
      },
      {
        date: "09-02 09:00",
        title: "双方保持沉默",
        desc: "原定演员团队未对此事回应，接替演员已进组围读，讨论逐渐转向「剧组话语权」话题。",
        tag: "待回应",
      },
    ],
    conclusion:
      "换角在影视行业并不罕见，真正引发讨论的是官方口径与爆料之间的落差。当「档期冲突」被反复用作万能解释时，公众对它的信任度反而在下降。目前事件仍停留在各方沉默阶段，尚无新证据。",
    views: "276 万",
    readingTime: "5 分钟",
  },
  {
    id: "streamer-preview-flop",
    title: "头部主播预告翻车：一场被反噬的「饥饿预告」",
    category: "直播电商",
    categorySlug: "live",
    heat: 93,
    status: "持续发酵",
    date: "2026-08-30",
    updatedAt: "2026-09-08",
    cover:
      "https://readdy.ai/api/search-image?query=Ring%20light%20and%20microphone%20on%20a%20minimal%20streaming%20desk%20setup%2C%20warm%20coral%20and%20amber%20accent%20lighting%2C%20clean%20dark%20background%2C%20editorial%20photography%2C%20cinematic%20soft%20shadows%2C%20high%20detail&width=800&height=600&seq=gualine-live-ringlight-04&orientation=landscape",
    tags: ["直播", "预告翻车", "价格争议"],
    summary:
      "提前半个月预热「全网最低价」，开播后却被发现优惠门槛复杂、部分商品价格更高，粉丝与主播之间出现明显裂痕。",
    background:
      "一位以「帮粉丝砍价」立住人设的头部主播，提前半个月开始预告年度大促。大量粉丝守着开播时间下单后，晒出价格对比图质疑「最低价」名不副实。",
    people: [
      { name: "头部主播 E 某", role: "预告与主推方" },
      { name: "品牌供应链", role: "价格与赠品提供方" },
      { name: "资深粉丝团", role: "价格对比的整理者" },
      { name: "比价博主「瓜农老张」", role: "第三方数据核对" },
    ],
    timeline: [
      {
        date: "08-30 12:00",
        title: "半个月预热启动",
        desc: "主播连续发布多条预告短视频，强调「全网最低」「只宠粉，不套路」。",
        tag: "预热",
      },
      {
        date: "09-05 20:00",
        title: "大促开播，销量暴涨",
        desc: "开播两小时多个主推链接售罄，直播间人气达到峰值，弹幕以「冲」为主。",
        tag: "开播",
      },
      {
        date: "09-06 11:00",
        title: "价格对比图刷屏",
        desc: "有粉丝整理出同款商品在其他平台的价格与赠品差异，指出部分链接实际更贵。",
        tag: "反转",
      },
      {
        date: "09-07 15:00",
        title: "主播回应「门槛不同」",
        desc: "主播解释称不同链接的满减与赠品规则不同，需要综合计算，但该说法未能说服多数质疑者。",
        tag: "回应",
      },
      {
        date: "09-08 10:00",
        title: "第三方核对数据公布",
        desc: "比价博主逐条核对后指出，约三成主推商品确无价格优势，事件仍在持续讨论中。",
        tag: "持续",
      },
    ],
    conclusion:
      "「最低价」是把双刃剑：它能快速聚拢流量，也意味着任何一条商品的价格失守都会反噬信任。这次事件暴露的不是选品能力，而是预热口径与真实优惠结构之间的落差。截至现在，双方仍在拉扯，粉丝的耐心正在被消耗。",
    views: "521 万",
    readingTime: "8 分钟",
  },
  {
    id: "variety-editing-drama",
    title: "综艺剪辑惹的祸：一段预告引出「组内不合」猜测",
    category: "综艺",
    categorySlug: "variety",
    heat: 79,
    status: "已澄清",
    date: "2026-06-18",
    updatedAt: "2026-06-27",
    cover:
      "https://readdy.ai/api/search-image?query=Television%20editing%20timeline%20screen%20glow%20in%20a%20dark%20minimal%20studio%2C%20warm%20coral%20and%20amber%20light%20accents%2C%20cinematic%20editorial%20photography%2C%20soft%20reflections%2C%20high%20detail&width=800&height=600&seq=gualine-variety-editing-05&orientation=landscape",
    tags: ["剪辑", "预告", "组内不合"],
    summary:
      "节目预告把两段不同时间的画面剪在一起，制造出「当场翻脸」的观感，正片播出后才发现完全是误会。",
    background:
      "一档旅行真人秀在正片上线前放出 40 秒预告，其中一段嘉宾表情不悦的画面被大量解读为矛盾现场，话题热度远超节目本身。",
    people: [
      { name: "常驻嘉宾 F 某", role: "预告画面的当事人" },
      { name: "节目剪辑组", role: "预告制作方" },
      { name: "嘉宾 G 某", role: "被猜测的对立方" },
      { name: "综艺观察博主", role: "逐帧对比的解读方" },
    ],
    timeline: [
      {
        date: "06-18 20:00",
        title: "40 秒预告上线",
        desc: "预告以一段快速切换的冲突画面收尾，弹幕瞬间被「撕起来了？」刷屏。",
        tag: "预告",
      },
      {
        date: "06-19 10:00",
        title: "猜测升级为话题",
        desc: "多个账号开始分析嘉宾关系，衍生出「小团体」等多种说法，节目未播先热。",
        tag: "发酵",
      },
      {
        date: "06-24 20:00",
        title: "正片播出，画面对不上",
        desc: "观众发现预告中的冲突画面实际来自两个完全不同的时段，中间隔了整整一天。",
        tag: "反转",
      },
      {
        date: "06-27 14:00",
        title: "节目组承认剪辑手法",
        desc: "节目组回应称预告为「提高节奏感」进行了合并剪辑，承认容易造成误读，并向观众致意。",
        tag: "回应",
      },
    ],
    conclusion:
      "预告片的剪辑自由度，和观众对「真实记录」的期待之间存在天然张力。这次事件没有输家也没有赢家，但它提醒了内容方：制造悬念可以，牺牲语境的剪辑迟早会被逐帧拆穿。",
    views: "204 万",
    readingTime: "5 分钟",
  },
  {
    id: "band-reunion-breakup",
    title: "老牌乐队复出巡演又光速解散，中间发生了什么",
    category: "音乐演出",
    categorySlug: "music",
    heat: 74,
    status: "已结束",
    date: "2026-05-09",
    updatedAt: "2026-05-30",
    cover:
      "https://readdy.ai/api/search-image?query=Electric%20guitar%20leaning%20against%20an%20amplifier%20on%20a%20minimal%20stage%2C%20warm%20amber%20spotlight%2C%20coral%20tones%2C%20cinematic%20editorial%20photography%2C%20moody%20atmosphere%2C%20high%20detail&width=800&height=600&seq=gualine-band-reunion-06&orientation=landscape",
    tags: ["复出", "解散", "巡演"],
    summary:
      "解散多年的乐队宣布复出并开启巡演，两个月后突然宣布终止合作，官方理由是「理念分歧」。",
    background:
      "一支在十年前解散的乐队，因为一次纪念演出重新聚首，随后宣布复出并开启全国巡演，门票一度售罄。巡演进行到一半时，成员集体发布声明终止合作。",
    people: [
      { name: "主唱 H 某", role: "复出发起成员" },
      { name: "吉他手 I 某", role: "巡演期间离队者" },
      { name: "巡演主办方", role: "场次与票务协调" },
      { name: "老乐迷群体", role: "情绪最复杂的一方" },
    ],
    timeline: [
      {
        date: "05-09 20:00",
        title: "纪念演出重聚",
        desc: "乐队在音乐节上临时合体演唱三首老歌，现场反响热烈，复出话题冲上热搜。",
        tag: "重聚",
      },
      {
        date: "05-15 12:00",
        title: "官宣复出并开启巡演",
        desc: "宣布全国六城巡演，首批门票开售即售罄，加场呼声高涨。",
        tag: "复出",
      },
      {
        date: "05-24 09:00",
        title: "巡演中途成员停演",
        desc: "第三站演出前吉他手临时缺席，官方以「身体原因」解释，现场改为精简编制。",
        tag: "异常",
      },
      {
        date: "05-30 18:00",
        title: "集体声明终止合作",
        desc: "成员发布联合声明称「在音乐方向与巡演安排上存在难以调和的分歧」，剩余场次取消并全额退票。",
        tag: "解散",
      },
    ],
    conclusion:
      "复出对于老乐队来说，情怀是敲门砖，作品与默契才是能不能走下去的地基。当巡演的商业节奏快过团队重新磨合的速度，分歧就会在舞台上暴露出来。这次体面的退票处理，算是给老乐迷留了最后一点尊重。",
    views: "168 万",
    readingTime: "6 分钟",
  },
  {
    id: "shortdrama-plagiarism",
    title: "短剧分镜被指抄袭：一场「像不像」的拉锯战",
    category: "短剧影视",
    categorySlug: "drama",
    heat: 85,
    status: "持续发酵",
    date: "2026-08-05",
    updatedAt: "2026-08-24",
    cover:
      "https://readdy.ai/api/search-image?query=Stack%20of%20film%20reels%20and%20script%20pages%20on%20a%20minimal%20desk%20with%20warm%20side%20light%2C%20coral%20and%20amber%20tones%2C%20cinematic%20editorial%20photography%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=800&height=600&seq=gualine-drama-script-07&orientation=landscape",
    tags: ["短剧", "抄袭指控", "分镜对比"],
    summary:
      "一部爆款短剧被指分镜与另一部小众作品高度相似，双方各自发布对比视频，观众分成两派。",
    background:
      "短剧《长夜信号》凭借紧凑节奏成为平台爆款，播放量破亿后，有创作者指出其多个关键分镜与一部三年前的小众短片高度相似。",
    people: [
      { name: "《长夜信号》制作团队", role: "被指控方" },
      { name: "短片《雾港》导演组", role: "指控方" },
      { name: "平台内容审核", role: "内容合规评估方" },
      { name: "影评博主「扒帧君」", role: "逐帧对比分析" },
    ],
    timeline: [
      {
        date: "08-05 14:00",
        title: "短剧播放量破亿",
        desc: "《长夜信号》登顶平台热播榜，相关话题持续上榜，制作团队开始预热第二季。",
        tag: "爆火",
      },
      {
        date: "08-09 16:00",
        title: "短片导演发文指控",
        desc: "《雾港》导演发布对比视频，指出三处关键分镜在构图与运镜上高度相似。",
        tag: "指控",
      },
      {
        date: "08-14 11:00",
        title: "制作方回应「题材巧合」",
        desc: "制作方称两部作品都使用了常见类型片套路，否认存在直接抄袭，并强调未接触过对方作品。",
        tag: "回应",
      },
      {
        date: "08-24 15:00",
        title: "平台启动内容复核",
        desc: "平台表示已受理相关投诉并启动复核流程，在结论出具前不干预作品展播，事件仍在推进。",
        tag: "持续",
      },
    ],
    conclusion:
      "「分镜相似」与「实质性相似」之间隔着法律与行业标准两道门。目前双方都停留在舆论层面的对比举证，真正有裁决权的仍是平台复核与后续可能的专业鉴定。对创作者来说，保留创作过程材料，是这类争议里最实在的自保方式。",
    views: "297 万",
    readingTime: "7 分钟",
  },
  {
    id: "idol-vote-anomaly",
    title: "选秀投票数据异常，到底谁在「半夜发力」",
    category: "选秀竞技",
    categorySlug: "idol",
    heat: 82,
    status: "已澄清",
    date: "2026-04-22",
    updatedAt: "2026-04-30",
    cover:
      "https://readdy.ai/api/search-image?query=Rows%20of%20glowing%20stage%20spotlights%20above%20an%20empty%20arena%2C%20warm%20coral%20and%20amber%20tones%2C%20cinematic%20editorial%20photography%2C%20minimal%20composition%2C%20high%20detail&width=800&height=600&seq=gualine-idol-spotlights-08&orientation=landscape",
    tags: ["选秀", "投票异常", "数据质疑"],
    summary:
      "决赛夜某选手票数在凌晨出现明显跃升，引发「刷票」质疑，官方审计后公布异常来源为投票页面缓存。",
    background:
      "一场线上选秀进入决赛阶段，实时票数公示成为观众关注焦点。凌晨时段某位选手的票数曲线突然变得陡峭，截图迅速在社交平台扩散。",
    people: [
      { name: "选手 J 某", role: "票数异常当事人" },
      { name: "赛事数据团队", role: "票务统计与公示方" },
      { name: "对手粉丝后援会", role: "质疑发起方" },
      { name: "第三方数据观察者", role: "曲线分析" },
    ],
    timeline: [
      {
        date: "04-22 22:00",
        title: "决赛夜实时票数公示",
        desc: "平台开启实时票数展示，多位选手票数交替上升，比拼进入白热化。",
        tag: "决赛",
      },
      {
        date: "04-23 02:00",
        title: "凌晨票数曲线异动",
        desc: "有观众截取到 J 某票数在十分钟内大幅上升，质疑存在集中刷票行为。",
        tag: "质疑",
      },
      {
        date: "04-24 13:00",
        title: "粉丝后援会要求公开数据",
        desc: "多个后援会联合发声，要求赛事方公开投票明细与防刷机制。",
        tag: "发酵",
      },
      {
        date: "04-28 10:00",
        title: "官方公布审计结果",
        desc: "赛事方称异常源于投票页面的缓存重算，导致部分票数在显示层重复累加，并展示了修正后的曲线。",
        tag: "澄清",
      },
      {
        date: "04-30 16:00",
        title: "规则优化，事件收尾",
        desc: "赛事方宣布后续比赛改用新的票数展示方式，并引入实时异常提示，争议逐步平息。",
        tag: "收尾",
      },
    ],
    conclusion:
      "数据不透明是选秀类节目最容易踩的雷区。这次异常最终被解释为技术缓存问题，但在「刷票」二字已经先入为主的情况下，澄清永远比质疑慢半拍。真正的解法不是事后审计，而是让过程数据随时可查、可验。",
    views: "231 万",
    readingTime: "6 分钟",
  },
];